import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const PromptContainer = styled.div`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  padding: 15px 25px;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  gap: 15px;
  z-index: 10000;
  border: 1px solid #ff4d4f22;
  animation: slideUp 0.5s ease-out;

  @keyframes slideUp {
    from { transform: translate(-50%, 100px); opacity: 0; }
    to { transform: translate(-50%, 0); opacity: 1; }
  }

  @media (max-width: 480px) {
    width: 100%;
    bottom: 0;
    left: 0;
    transform: none;
    border-radius: 0;
    padding: 8px 12px;
    gap: 8px;
    min-height: 45px;
    
    animation: slideUpMobile 0.5s ease-out;
    
    @keyframes slideUpMobile {
      from { transform: translateY(100%); opacity: 0; }
      to { transform: translateY(0); opacity: 1; }
    }

    /* Hide subtitle to save vertical space */
    p { display: none; }
    
    h4 { 
      font-size: 13px; 
      margin: 0;
      white-space: nowrap;
    }
    
    button.install { 
      padding: 4px 10px; 
      font-size: 11px; 
      border-radius: 6px;
    }

    /* Adjust Close button for ultra-slim layout */
    button[aria-label="Close"] {
      top: 0;
      right: 2px;
      font-size: 14px;
    }
  }
`;

const TextContent = styled.div`
  flex: 1;
`;

const Title = styled.h4`
  margin: 0;
  color: #333;
  font-size: 16px;
`;

const Subtitle = styled.p`
  margin: 2px 0 0;
  color: #666;
  font-size: 13px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;

const Button = styled.button`
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.2s;

  &.install {
    background: #ff4d4f;
    color: white;
    &:hover { background: #ff7875; }
  }

  &.cancel {
    background: #f5f5f5;
    color: #666;
    &:hover { background: #e8e8e8; }
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 5px;
  right: 8px;
  background: none;
  border: none;
  color: #999;
  font-size: 18px;
  cursor: pointer;
  padding: 5px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;

  &:hover {
    color: #333;
  }

  @media (max-width: 480px) {
    top: 2px;
    right: 5px;
    font-size: 16px;
  }
`;


const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later.
      setDeferredPrompt(e);
      setIsVisible(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    // Show the install prompt
    deferredPrompt.prompt();

    // Wait for the user to respond to the prompt
    const { outcome } = await deferredPrompt.userChoice;
    console.log(`User response to the install prompt: ${outcome}`);

    // We've used the prompt, and can't use it again, throw it away
    setDeferredPrompt(null);
    setIsVisible(false);
  };

  const handleCancelClick = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <PromptContainer>
      <CloseButton onClick={handleCancelClick} aria-label="Close">×</CloseButton>
      <TextContent>
        <Title>ukezhavamatrimony.com</Title>
        <Subtitle>Install for fast access to your matrimony profile</Subtitle>
      </TextContent>
      <ButtonGroup>
        <Button className="install" onClick={handleInstallClick}>Install</Button>
      </ButtonGroup>
    </PromptContainer>
  );
};

export default PWAInstallPrompt;
